<template>
  <button
    type="button"
    class="theme-toggle"
    :aria-label="`Switch to ${nextTheme} mode`"
    :title="`Switch to ${nextTheme} mode`"
    @click="toggle"
  >
    <!-- the icon previews the mode you'll switch to -->
    <svg v-if="theme === 'dark'" viewBox="0 0 24 24" width="17" height="17" fill="none"
         stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4.5" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M4.9 4.9l1.5 1.5M17.6 17.6l1.5 1.5M19.1 4.9l-1.5 1.5M6.4 17.6l-1.5 1.5" />
    </svg>
    <svg v-else viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true">
      <path d="M20.7 14.6A8.8 8.8 0 0 1 9.4 3.3 9 9 0 1 0 20.7 14.6z" />
    </svg>
  </button>
</template>

<script>
import { applyTheme, getCurrentTheme, getStoredTheme, getSystemTheme, setTheme } from "@/helpers/theme";

export default {
  name: "theme-toggle",
  data () {
    return {
      theme: "dark"
    };
  },
  computed: {
    nextTheme () {
      return this.theme === "dark" ? "light" : "dark";
    }
  },
  mounted () {
    this.theme = getCurrentTheme();
    applyTheme(this.theme);
    // keep following the device preference while the user hasn't chosen
    this.mq = window.matchMedia && window.matchMedia("(prefers-color-scheme: light)");
    this.onMqChange = () => {
      if (!getStoredTheme()) {
        this.theme = getSystemTheme();
        applyTheme(this.theme);
      }
    };
    if (this.mq && this.mq.addEventListener) this.mq.addEventListener("change", this.onMqChange);
    else if (this.mq && this.mq.addListener) this.mq.addListener(this.onMqChange);
  },
  beforeDestroy () {
    if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener("change", this.onMqChange);
    else if (this.mq && this.mq.removeListener) this.mq.removeListener(this.onMqChange);
  },
  methods: {
    toggle () {
      this.theme = this.nextTheme;
      setTheme(this.theme);
    }
  }
};
</script>

<style scoped lang="scss">
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--outline, rgba(128, 128, 128, 0.4));
  background: transparent;
  color: var(--primary-text, #fff);
  cursor: pointer;
  transition: all 0.25s ease-in-out;

  svg {
    display: block;
  }

  &:hover {
    background: var(--accent-color, #ffcf02);
    border-color: var(--accent-color, #ffcf02);
    color: #000;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--accent-color, #ffcf02);
  }
}

// the light scheme's accent is a dark burgundy — the icon flips to white
// there so it never sits black-on-dark
:root[data-theme="light"] .theme-toggle:hover {
  color: #fff;
}
</style>
